/**
 * LanguageSwitcher — AppBar segmented control for en/es/fr/pt.
 * Current locale reads from `i18n.language`; selecting an option calls
 * `i18n.changeLanguage` (cookie write is the `languageChanged` handler).
 * No notification bell.
 */
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useCopy } from '@/hooks/useCopy';
import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from '@/i18n/constants';

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const { t } = useCopy();
  const current = i18n.language?.split('-')[0] ?? DEFAULT_LOCALE;

  return (
    <ToggleButtonGroup
      value={current}
      exclusive
      size="small"
      onChange={(_event, next: string | null) => {
        if (next) void i18n.changeLanguage(next);
      }}
      aria-label={t('common.language', 'Language')}
    >
      {SUPPORTED_LOCALES.map((code) => {
        const label = t(`lang.${code}`, code.toUpperCase());
        return (
          // color: 'text.primary' so the unselected state meets WCAG AA
          // contrast against the AppBar background.
          <ToggleButton key={code} value={code} aria-label={label} sx={{ color: 'text.primary' }}>
            {label}
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
}
